import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import LegalPage from './pages/LegalPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminContent from './pages/admin/AdminContent';
import AdminServices from './pages/admin/AdminServices';
import AdminPricing from './pages/admin/AdminPricing';
import AdminWorks from './pages/admin/AdminWorks';
import AdminLeads from './pages/admin/AdminLeads';
import { SiteProvider } from './context/SiteContext';
import { AuthProvider } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import ProtectedRoute from './pages/admin/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LangProvider>
          <AuthProvider>
            <SiteProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/legal/:type" element={<LegalPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<AdminDashboard />} />
                  <Route path="content" element={<AdminContent />} />
                  <Route path="services" element={<AdminServices />} />
                  <Route path="pricing" element={<AdminPricing />} />
                  <Route path="works" element={<AdminWorks />} />
                  <Route path="leads" element={<AdminLeads />} />
                </Route>
              </Routes>
            </SiteProvider>
          </AuthProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
